// extracted by mini-css-extract-plugin
export var badge = "dropdownSectionFeatures-module--badge--8dd6c";
export var feature = "dropdownSectionFeatures-module--feature--d8b21";
export var featureColumn = "dropdownSectionFeatures-module--featureColumn--f20db";
export var icon = "dropdownSectionFeatures-module--icon--62bef";
export var label = "dropdownSectionFeatures-module--label--d98b2";
export var text = "dropdownSectionFeatures-module--text--86305";
export var title = "dropdownSectionFeatures-module--title--cd8b5";